import React from "react";
import EmptylistNotification from "../billingPayment/EmptylistNotification";
import { TextWrapper, Wrapper } from "./VehicleorAssetDetails/AdditionalService/AdditionalService";
import styled from "styled-components";
import { CustomisedTertiaryButton } from "../../constants/common/StyledGlobalConstants";
import { useSelector } from "react-redux";
import { getPendoId } from "../../util/cfstPendoUtils";
import { DEVICE_BREAKPOINTS } from "../../constants/appConstants";
import PropTypes from "prop-types";

const { MOBILE } = DEVICE_BREAKPOINTS;

const TryAgainButton = styled(CustomisedTertiaryButton)`
  & span {
    padding: 8px 16px;
  }
`;

const SomethingWentWrongTryAgain = ({ handleTryAgain }) => {
  const { windowSize } = useSelector((state) => state.ACCOUNT);
  let textWrapperWidth = "auto";
  if (windowSize.width >= MOBILE) {
    textWrapperWidth = windowSize.width < 900 ? "71%" : "57%";
  }
  return (
    <EmptylistNotification
      title={"Something went wrong"}
      genericError={true}
      isJobFailed={true}
    >
      <Wrapper display="flex" flexDirection="column" gap="1rem" alignItems="center">
        <TextWrapper width={textWrapperWidth}>
          Something went wrong while loading this page.
        </TextWrapper>
        <Wrapper>
          <TryAgainButton
            id={getPendoId("try-again-button")}
            buttonHeight={"32px"}
            boxButton={true}
            ariaLabel="try again"
            onClick={handleTryAgain}
            fontSize="12px"
          >
            TRY AGAIN
          </TryAgainButton>
        </Wrapper>
      </Wrapper>
    </EmptylistNotification>
  );
};

SomethingWentWrongTryAgain.propTypes = {
  handleTryAgain: PropTypes.func.isRequired,
};

export default SomethingWentWrongTryAgain;